import React from "react";
import "./LoadingElement.css";
import { PROCESSINGSTATES } from "../../types/interfaces";


interface LoadingElementProps {
    state: PROCESSINGSTATES
}

const stateClassNameSuffix = (state: PROCESSINGSTATES) => {
    switch (state) {
        case PROCESSINGSTATES.processing:
            return "Processing"
        case PROCESSINGSTATES.succeeded:
            return "Success"
        case PROCESSINGSTATES.failed:
            return "Failed"
    }
}
    
const LoadingElement: React.FC<LoadingElementProps> = (props) => {
    return(
        <div className="loadingElemCont">
            <div className={"loadingElemAnim loadingElemAnim" + stateClassNameSuffix(props.state)}>
                <div className={"blockLeft blockLeft" + stateClassNameSuffix(props.state)}></div>
                <div className={"blockLeft blockRight" + stateClassNameSuffix(props.state)}></div>
            </div>
        </div>
    )
}

export {
    LoadingElement
}